import { defineComponent as _defineComponent } from 'vue'
import { Button } from '@tencent/wphk-design';
import { ScreenDialog } from '@tencent/wphk-ui';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { computed, ref } from 'vue';
import { getPrizeImageByBatch } from '../config/prize-config';
import { CouponType } from '@tencent/wphk-act-base-types';
import { ACT_2608_ADTAG_JUMP, LICENSE_DISPLAY_TEXT } from '../config';
import { mittBus, MITT_TYPES } from '@/business/mitt-bus';

/**
 * 中奖信息接口
 */
interface PrizeInfo {
  /** 奖品 ID (如 "CPXXXXXXXX") */
  prizeId: string;
  /** 用户券 ID */
  userCouponId?: string;
  /** 券类型 */
  couponType?: CouponType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'get-prize-dialog',
  emits: ['hide'],
  setup(__props, { expose, emit }) {



// Refs
const prizeDialog = ref();
const currentPrizeInfo = ref<PrizeInfo | null>(null);
/**
 * 奖品 ID (用于埋点和图片映射)
 */
const prizeId = computed(() => currentPrizeInfo.value?.prizeId || '');

/**
 * 奖品背景图 (根据 prizeId 映射完整切图)
 */
const prizeImage = computed(() => {
  if (!currentPrizeInfo.value) return '';
  const { prizeId } = currentPrizeInfo.value;
  return getPrizeImageByBatch(prizeId);
});

/**
 * 显示中奖弹窗
 */
const showPrizeDialog = (prizeInfo: PrizeInfo) => {
  currentPrizeInfo.value = prizeInfo;
  prizeDialog.value?.show();
};

/**
 * 分享再HK$3 按钮点击
 */
const onShareCoupon = () => {
  prizeDialog.value?.hide();
  mittBus.emit(MITT_TYPES.bannerShareCouponClick);
};

/**
 * 查看优惠券按钮点击
 */
const onViewCoupon = () => {
  if (!currentPrizeInfo.value) return;

  jumpPage.goMyCoupons({ adtag: ACT_2608_ADTAG_JUMP });
  prizeDialog.value?.hide();
};

/**
 * 弹窗关闭回调
 */
const onHideDialog = () => {
  emit('hide');
};

// 暴露方法给父组件
expose({
  showDialog: showPrizeDialog,
});

return { __sfc: true,emit, prizeDialog, currentPrizeInfo, prizeId, prizeImage, showPrizeDialog, onShareCoupon, onViewCoupon, onHideDialog, Button, ScreenDialog, LICENSE_DISPLAY_TEXT }
}

})